import React from 'react'
import { Link } from 'gatsby'


import * as styles from './footer.module.css'

const Footer = () => (
  <div className="footer">
    <div className={styles.container}>
      <ul className={styles.utilMenu}>
        <li>
          <Link to="/privacy-policy">
            Privacy policy
          </Link>
        </li>
        <li>
          <Link to="/term-of-use">
            Term of use
          </Link>
        </li>
      </ul>
      <div className={styles.copyright}>
        <p><Link to="/">Copyright (c) Mogra Radio</Link></p>
      </div>
      <div className={styles.contact}>
        <h2>Contact</h2>
        <p>
          <a href="mailto:info@mogra.fm">info@mogra.fm</a></p>
      </div>
    </div>
  </div>
)

export default Footer
